import { getFileIconAndColorTailwind } from '@/utils'
import { FAIcon } from './fa-icon'

interface Props {
  className?: string

  file: File | { name: string; url: string }

  fallbackColor?: string
}

export function FileIcon({
  className,

  file,

  fallbackColor,
}: Props) {
  const [icon, color] = getFileIconAndColorTailwind(file.name, fallbackColor)

  return (
    <FAIcon
      className={className}
      style={{ color }}
      icon={icon}
      type="light"
      fixedWidth
    />
  )
}
